/**
 * DataPointPresenter - Displays a data point with icon, value, and label
 *
 * NOTE: This presenter component is separated from DataPointWithIcon.tsx for Module Federation.
 * It contains the same UI logic but receives all data via props instead of MobX injection.
 * Used for wind speed, humidity, precipitation in weather widgets.
 */

import * as React from 'react'

interface IProps {
  icon: JSX.Element
  value: string
  label: string
}

export default function DataPointPresenter({
  icon,
  value,
  label,
}: IProps): JSX.Element {
  return (
    <div className="row x-start">
      <div className="row x-start y-center no-white-space-wrap">
        {icon}
        <span className="text bold grey-10 mx2">{value}</span>
        <span className="text grey-light">{label}</span>
      </div>
    </div>
  )
}
